export default __webpack_public_path__ + "static/media/wallet-bottom.8e93fba6.svg";